import React, { useState } from "react";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Box,
  Popover,
  Typography,
} from "@mui/material";
import { ChromePicker } from "react-color";
import Palette from "../../Plan/Palette";
import CustomEditActionButtons from "./EditActionButtons";

function EditRowDialog({ table, row, initialData, handleUpdateOrder }) {
  const [newRow, setNewRow] = useState({
    item_name: initialData.item_name || "",
    item_id: initialData.item_id || "",
    material_grouping: initialData.material_grouping || "",
    color: initialData.gantt_color || "#000000",
    safety_stock: initialData.safety_stock || 0,
  });
  const [activeColor, setActiveColor] = useState(initialData.gantt_color);
  const [anchorEl, setAnchorEl] = useState(null);
  const onTileClick = (color) => {
    handleInputChange("gantt_color", color);
    setActiveColor(color);
  };
  const setEditingRow = (field, value) => {
    table.setEditingRow({
      ...row,
      [field]: value,
    });
  };
  const handleInputChange = (field, value) => {
    setNewRow((prev) => ({ ...prev, [field]: value }));
    setEditingRow(field, value);
    setActiveColor(value);
  };
  const handleOpenChromePicker = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseChromePicker = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <>
      <DialogTitle
        variant="h5"
        sx={{ fontSize: "18px !important", color: "#111" }}
      >
        제품정보 수정
      </DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
      >
        <TextField
          label="제품명"
          value={newRow.item_name}
          onChange={(e) => handleInputChange("item_name", e.target.value)}
          fullWidth
        />
        <TextField
          label="Material Grouping"
          // type="number"
          value={newRow.material_grouping}
          onChange={(e) =>
            handleInputChange("material_grouping", e.target.value)
          }
          fullWidth
        />
        <TextField
          label="안전재고"
          fullWidth
          name="safety_stock"
          type="number"
          value={newRow.safety_stock}
          onChange={(e) => handleInputChange("safety_stock", e.target.value)}
        />
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle1" gutterBottom>
            색상 선택
          </Typography>
          <Palette
            handleOpenChromePicker={handleOpenChromePicker}
            title="더 많은 색상 선택"
            handleInputChange={handleInputChange}
            colors1={[
              { value: "#96bef0" },
              { value: "#ffb5ea" },
              { value: "#8affad" },
              { value: "#9ccdff" },
              { value: "#ea9cfb", lightLabel: true },
              { value: "#f0be68", lightLabel: true },
              { value: "#64f0f0", lightLabel: true },
              { value: "#efb9b9", lightLabel: true },
              { value: "#6ff080", lightLabel: true },
              { value: "#b7e1f0", lightLabel: true },
            ]}
            colors2={[
              { value: "#ffd179" },
              { value: "#c5ff7b" },
              { value: "#64b9ff" },
              { value: "#d87570" },
              { value: "#aff3b2", lightLabel: true },
              { value: "#a2a6d8", lightLabel: true },
              { value: "#ffbe96", lightLabel: true },
              { value: "#c882e2", lightLabel: true },
              { value: "#c4a9d3", lightLabel: true },
              { value: "#aad2e8", lightLabel: true },
            ]}
            activeColor={activeColor}
            setActiveColor={setActiveColor}
            onTileClick={onTileClick}
          />
        </Box>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleCloseChromePicker}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Box sx={{ p: 2, backgroundColor: "rgba(0, 0, 0, 0.6)" }}>
            <ChromePicker
              color={newRow.color}
              onChangeComplete={(color) => {
                handleInputChange("color", color.hex);
                handleCloseChromePicker();
              }}
            />
          </Box>
        </Popover>
      </DialogContent>
      <DialogActions>
        {/* <ActioButtons variant="text" table={table} row={row} /> */}
        <CustomEditActionButtons
          table={table}
          row={row}
          handleUpdateOrder={handleUpdateOrder}
          newRow={newRow}
        />
      </DialogActions>
    </>
  );
}

export default EditRowDialog;
